import React from 'react';
import { Center, Container, Stack } from '@fiverr-private/layout_components';
import { Text } from '@fiverr-private/typography';
import { TierDetails, ServiceOption } from '../types';
import { TableCell, TableRow } from '../../shared/Table';
import { ServiceAvailabilityIndicator } from '../ServiceAvailabilityIndicator';

interface ServiceSubOptionsProps {
    serviceOption: ServiceOption;
    tierDetails: TierDetails[];
}

export const ServiceSubOptions = ({ serviceOption, tierDetails }: ServiceSubOptionsProps) => (
    <>
        {serviceOption.subOptions.map((subOption) => (
            <TableRow key={subOption.id}>
                <TableCell isSticky backgroundColor="grey_100">
                    <Stack paddingX="4" paddingY="7" alignItems="center" columnGap="4">
                        <Container>
                            <Container backgroundColor="grey_600" width="6px" height="6px" borderRadius="circle" />
                        </Container>
                        <Text size="b_sm">{subOption.name}</Text>
                    </Stack>
                </TableCell>

                {tierDetails.map((tierDetail) => {
                    const detailsOption = tierDetail.options.find((option) => option.optionId === serviceOption.id);
                    const subOpt = detailsOption?.subOptions.find((option) => option.optionId === subOption.id);

                    if (!subOpt) {
                        return <TableCell key={tierDetail.id} backgroundColor="grey_100" />;
                    }

                    return (
                        <TableCell key={`${tierDetail.id}-${subOpt.optionId}`} backgroundColor="grey_100">
                            <Center paddingX="4" paddingY="7">
                                <ServiceAvailabilityIndicator status={subOpt.availabilityStatus} />
                            </Center>
                        </TableCell>
                    );
                })}
            </TableRow>
        ))}
    </>
);
